export function trackEvent(eventName, params = {}) {
  if (typeof window === "undefined") return
  if (typeof window.gtag !== "function") return

  try {
    window.gtag("event", eventName, params)
  } catch (err) {
    // Analytics must never interrupt the game loop.
  }
}
